import { API_CONFIG, handleApiError, ApiResponse } from './apiConfig'

// Interfaces pour les données
export interface Pays {
  id: number
  code: string
  nom: string
  indicatif?: string
}

export interface Collectivite {
  id: number
  nom: string
  code?: string
  description?: string
  rccm?: string
  adresse?: string
  telephone?: string
  email?: string
  date_creation?: string
  pays_id?: number
  secteurs?: string[]
}

export interface CreateCollectiviteData {
  nom: string
  rccm?: string
  adresse: string
  telephone: string
  email: string
  date_creation: string
  pays_id: number
  secteurs: string[]
}

class GeneralService {
  /**
   * Récupérer la liste des pays
   */
  async getPays(): Promise<ApiResponse<Pays[]>> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/pays`, {
        method: 'GET',
        headers: API_CONFIG.headers
      })

      const data = await response.json()
      return data
    } catch (error) {
      return handleApiError(error)
    }
  }

  /**
   * Récupérer la liste des collectivités/entreprises
   */
  async getCollectivites(): Promise<ApiResponse<Collectivite[]>> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/collectivites`, {
        method: 'GET',
        headers: API_CONFIG.headers
      })

      const data = await response.json()
      return data
    } catch (error) {
      return handleApiError(error)
    }
  }

  /**
   * Créer une collectivité
   */
  async createCollectivite(data: CreateCollectiviteData): Promise<ApiResponse<Collectivite>> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/collectivites/create`, {
        method: 'POST',
        headers: API_CONFIG.headers,
        body: JSON.stringify(data)
      })

      const result = await response.json()
      return result
    } catch (error) {
      return handleApiError(error)
    }
  }
}

export default new GeneralService()

